export const ROLE_SMS_ADMIN = 1;
export const ROLE_PARTIAL_ADMIN = 2;
export const ROLE_SUPER_ADMIN = 3;
